import { AlertTriangle, X } from "lucide-react";

export default function ConfirmDialog({
    open = true,
    title = "Are you sure?",
    message = "",
    confirmText = "Confirm",
    cancelText = "Cancel",
    destructive = false,
    onConfirm,
    onCancel,
}) {
    if (open === false) return null;
    return (
        <div
            className="fixed inset-0 bg-slate-900/60 z-[60] flex items-center justify-center p-4"
            onClick={onCancel}
            data-testid="confirm-dialog"
        >
            <div
                className="bg-white border border-slate-300 shadow-[6px_6px_0_0_rgba(15,23,42,0.9)] max-w-sm w-full"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between bg-slate-50">
                    <div className="flex items-center gap-2">
                        {destructive ? (
                            <AlertTriangle className="w-4 h-4 text-red-600" />
                        ) : (
                            <AlertTriangle className="w-4 h-4 text-amber-600" />
                        )}
                        <span className="font-display font-bold uppercase text-sm">{title}</span>
                    </div>
                    <button onClick={onCancel} data-testid="confirm-close">
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="p-4">
                    <p className="text-sm text-slate-700 leading-relaxed">{message}</p>
                </div>
                <div className="px-4 py-3 border-t border-slate-200 bg-slate-50 flex justify-end gap-2">
                    <button
                        onClick={onCancel}
                        className="btn-outline"
                        data-testid="confirm-cancel"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`btn-primary ${destructive ? "!bg-red-600 hover:!shadow-[4px_4px_0_0_#7f1d1d]" : ""}`}
                        data-testid="confirm-yes"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
